export const SELECTORS = {
  PORTAL_ROOT: 'portal-root',
}
